<template>
  <div class="price-comparison bg-background-light px-6 py-10 md:py-16 text-center tracking-0.15px">
    <div class="mx-auto w-full max-w-md">
      <!-- Title -->
      <h6 class="text-lg md:text-2xl font-bold text-primary mb-2 md:mb-4">
        {{ content.title }}
      </h6>

      <!-- Description -->
      <div
        v-dompurify-html="content.description"
        class="richtext mx-auto"
        data-testid="price-comparison-description"
      ></div>

      <!-- Comparison block -->
      <div class="price-comparison__comparison mt-6 md:mt-8 text-left">
        <!-- Plus Provider row -->
        <ProviderCard
          :content="content.plusProviderCard"
          data-testid="plus-provider-card" />

        <!-- Divider -->
        <hr class="price-comparison__divider my-4 border-0 border-t border-gray-divider" />

        <!-- Non Plus Provider row -->
        <ProviderCard
          :content="content.nonPlusProviderCard"
          data-testid="non-plus-provider-card" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ProviderCard from '@/components/molecules/ProviderCard/index.vue'
import { PriceComparison } from '@/model'

export default defineComponent({
  components: {
    ProviderCard
  },
  props: {
    content: {
      type: Object as () => PriceComparison,
      required: true,
      validator: (value: PriceComparison) => value instanceof PriceComparison
    }
  }
})
</script>
